export default __webpack_public_path__ + "static/media/Halloween-Ducks.9c4629b3.jpg";